// src/contexts/ReservationContext.js
import React, { createContext, useContext, useState } from "react";

const ReservationContext = createContext();

export const ReservationProvider = ({ children }) => {
  const [hasFetchedReservation, setHasFetchedReservation] = useState(false);

  return (
    <ReservationContext.Provider value={{ hasFetchedReservation, setHasFetchedReservation }}>
      {children}
    </ReservationContext.Provider>
  );
};

export const useReservationContext = () => useContext(ReservationContext);
